import { NotificationService } from "../../services/notification.service";
import { jSith } from "../../util/jquery-replacement";

import { Component, ChangeDetectorRef, ElementRef, NgZone, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";

@TypeManagerDecorator("s25-notifications")
@Component({
    selector: "s25-notifications",
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Default,
    template: `
        <div
            class="ngNotification--container {{ notifications.length ? 'multiple-notifications' : '' }}"
            role="region"
            aria-label="Notifications"
            id="S25AppNotifications"
            aria-live="polite"
            tabindex="0"
        >
            @if (notifications.length) {
                <div class="ngNotification--container__dismiss-wrapper" role="button" tabindex="0" (click)="collapse()">
                    @if (notifications.length > 1) {
                        <p class="count">{{ notifications.length }} Notifications</p>
                    }
                    @if (notifications.length < 2) {
                        <p class="count">{{ notifications.length }} Notification</p>
                    }
                    @if (notifications.length > 1) {
                        <button
                            class="aw-button aw-button--outline c-margin-right--quarter"
                            (click)="removeAllNotifs()"
                        >
                            Dismiss All
                        </button>
                    }
                    <button class="notification-collapse-wrapper">
                        <s25-ng-icon
                            [type]="'caretDown'"
                            [svgClass]="'notification-collapse'"
                            [label]="'Collapse or Expand Notification Container'"
                        ></s25-ng-icon>
                    </button>
                </div>
            }
            <div class="ngNotification--container__snackbar-wrapper">
                @for (n of notifications; track $any(n).id) {
                    <div class="ngNotification--container__snackbar c-posRelative ngNotification">
                        <div class="ngNotification--container__notch"></div>
                        <div [attr.class]="'ngNotification--container__body ' + $any(n).notificationClass">
                            <div class="ngNotification--container__content">
                                <s25-ng-icon
                                    [type]="'info'"
                                    [svgClass]="'snackbar-icon c-margin-right--single'"
                                ></s25-ng-icon>
                                <p
                                    class="ngNotification--container__content__text c-margin-right--quarter"
                                    [innerHTML]="$any(n).msg"
                                ></p>
                            </div>
                            <button
                                class="ngNotification--container__close aw-button aw-button--outline"
                                (click)="$any(n).remove()"
                            >
                                <s25-ng-icon [type]="'close'" [svgClass]="'ngCpointer'"></s25-ng-icon>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
        @if (barNotification.message && barNotification.barOpen) {
            <div class="notification-bar">
                <p class="notification-message">
                    {{ barNotification.message }}
                </p>
                @if (barNotification.showButton && barNotification.buttonFn) {
                    <button (click)="barNotification.buttonFn()" class="c-textButton">
                        {{ barNotification.buttonMsg }}
                    </button>
                }
                @if (barNotification.showClose) {
                    <button
                        class="c-button c-button--flat"
                        (click)="barNotification.remove()"
                        aria-label="Close"
                        role="button"
                        tabindex="0"
                    >
                        <s25-ng-icon [type]="'close'"></s25-ng-icon>
                    </button>
                }
            </div>
        }
    `,
})
export class S25NotificationsComponent implements OnInit {
    private static changeDetectionRef: ChangeDetectorRef;

    public static refresh(): void {
        if (S25NotificationsComponent.changeDetectionRef) {
            S25NotificationsComponent.changeDetectionRef.detectChanges();
        }
    }

    constructor(
        private elementRef: ElementRef,
        private zone: NgZone,
        private cd: ChangeDetectorRef,
    ) {
        S25NotificationsComponent.changeDetectionRef = cd;
        // bridge to AngularJS; used for AngJS to set model values and call setter fns
        this.elementRef.nativeElement.angBridge = this;
    }

    public removeAllNotifs() {
        jSith.ngforEach(this.notifications, (value: any): any => {
            setTimeout((): any => {
                NotificationService.remove(value);
            });
        });
    }

    public collapse() {
        let container = document.getElementsByClassName("multiple-notifications");
        let svg = document.getElementsByClassName("notification-collapse");
        if (!this.collapsed) {
            container && jSith.setCss(container, { "max-height": "50px" });
            svg && jSith.setCss(svg, { transform: "rotate(180deg)" });
            this.collapsed = true;
        } else {
            container && jSith.setCss(container, { "max-height": "300px" });
            svg && jSith.setCss(svg, { transform: "rotate(-0deg)" });
            this.collapsed = false;
        }
    }

    public init = false;

    public notifications: any = NotificationService.getAll();

    public barNotification: any = NotificationService.getBarNotification();

    public collapsed = false;

    ngOnInit(): void {
        this.init = true;
        (document.querySelector(".ngNotification--container") as HTMLElement)?.focus();
    }
}
